<template>
  <!-- <a
    :class="$route.name === links_menu[4].pathName ? 'router-link-active' : ''"
    class="h-100"
    target="_blank"
    href="https://play.gtowizard.com/?utm_source=gtowizard&utm_medium=web&utm_campaign=play&utm_content=header"
  > -->
  <router-link
    class="h-100"
    :class="$route.name === links_menu[4].pathName ? 'router-link-active' : ''"
    :to="{ name: 'Play', query: { utm_source: 'menu' } }"
    data-tst="play_menu_link_main"
  >
    <NavCard
      :item="links_menu[4]"
      class="navcard_menu navcard_menu-trigger navcard_router-link"
      :style="'--clr-text:var(--clr-grey-2); --padding: 0 1rem;'"
      :hasSub="false"
      :class="{ 'navcard_router-link_active': $route.name === links_menu[4].pathName }"
    />
  </router-link>
  <!-- </a> -->
</template>

<script>
import links_mix from '@/mixins/links_mix'

export default {
  name: 'PlayMenu',
  mixins: [links_mix],
}
</script>
